import React, { useMemo, useState } from "react";
import { DatePicker, Badge, Tooltip } from "antd";
import dayjs from "dayjs";

const CustomDatePicker = ({ getAllLog, handleDateSelect }) => {

    console.log("getAllLog",getAllLog);
    
    const [selectedDate, setSelectedDate] = useState(dayjs());

    const dateStats = useMemo(() => {
    const stats = {};

    getAllLog?.forEach((item) => {
        const startDate = dayjs(item.check_in);
        const endDate = dayjs(item.check_out);

        if (!startDate.isValid() || !endDate.isValid()) return;

        let currentDate = startDate.startOf("day");
        const lastDate = endDate.startOf("day");

        while (currentDate.isSame(lastDate, "day") || currentDate.isBefore(lastDate, "day")) {
            const dateKey = currentDate.format("YYYY-MM-DD");

            if (!stats[dateKey]) {
                stats[dateKey] = {
                    reserved: 0,
                    occupied: 0,
                    exited: 0,
                    check_out: 0,
                };
            }

            if (item.status === "reserved") stats[dateKey].reserved++;
            if (item.status === "occupied") stats[dateKey].occupied++;
            if (item.status === "exited") stats[dateKey].exited++;
            if (item.status === "check_out") stats[dateKey].check_out++;

            currentDate = currentDate.add(1, "day");
        }
    });

    return stats;
}, [getAllLog]);

    const handleChange = (date, row) => {
        setSelectedDate(date);
        const formattedDate = date ? date.format("YYYY-MM-DD") : null;
        handleDateSelect(date, formattedDate);
    };

    return (
        <DatePicker
            size="large"
            allowClear={false}
            defaultValue={dayjs()}
            onChange={handleChange}
            format="DD/MM/YYYY"
            // ✅ Increase popup width so 2 badges fit per row comfortably
            popupStyle={{ width: 420 }}
            style={{ width: "100%" }}
            cellRender={(current, info) => {
                if (info.type !== "date") return info.originNode;

                const dateKey = current.format("YYYY-MM-DD");
                const data = dateStats[dateKey];

                const isToday = current.isSame(dayjs(), "day");
                const isSelected = selectedDate && current.isSame(selectedDate, "day");

                const cellStyle = {
                    minHeight: 58,
                    padding: "4px 3px",
                    textAlign: "center",
                    borderRadius: 6,
                    margin: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: isSelected ? "#1677ff" : isToday ? "#e6f4ff" : data ? "#fff" : "transparent",
                    border: isSelected
                        ? "2px solid #1677ff"
                        : isToday
                            ? "2px solid #1677ff"
                            : data
                                ? "1px solid #d9d9d9"
                                : "none",
                };

                const dateNumStyle = {
                    fontWeight: isToday || isSelected ? "bold" : "normal",
                    color: isSelected ? "#fff" : isToday ? "#1677ff" : "inherit",
                    fontSize: 12,
                    lineHeight: 1,
                };

                const badgeRowStyle = {
                    display: "flex",
                    flexDirection: "row",       // ✅ badges side by side
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                };

                if (!data) {
                    return (
                        <div style={cellStyle}>
                            <div style={dateNumStyle}>{current.date()}</div>
                        </div>
                    );
                }

                return (
                    <Tooltip
                        title={
                            <div>
                                <div>Reserved: {data.reserved || 0}</div>
                                <div>Occupied: {data.occupied || 0}</div>
                                <div>Exited: {data.exited || 0}</div>
                                <div>Check Out: {data.check_out || 0}</div>
                            </div>
                        }
                    >
                        <div style={cellStyle}>
                            <div style={dateNumStyle}>{current.date()}</div>

                            {/* ✅ Both badges sit in the same row */}
                            <div style={badgeRowStyle}>
                                {data.reserved > 0 && (
                                    <Badge
                                        count={data.reserved}
                                        style={{
                                            backgroundColor: "#3314fa",
                                            fontSize: 10,
                                            height: 16,
                                            lineHeight: "16px",
                                            padding: "0 4px",
                                            minWidth: 16,
                                        }}
                                    />
                                )}
                                {data.occupied > 0 && (
                                    <Badge
                                        count={data.occupied}
                                        style={{
                                            backgroundColor: "#246702",
                                            fontSize: 10,
                                            height: 16,
                                            lineHeight: "16px",
                                            padding: "0 4px",
                                            minWidth: 16,
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </Tooltip>
                );
            }}
        />
    );
};

export default CustomDatePicker;